import React, { memo } from "react";

import Context from "shared/util/Context";
import Str from "shared/components/Str";
import allowMobileMode from "shared/util/allowMobileMode";
import getMobileType from "shared/util/getMobileType";
import { isDesktop, isMobile } from "shared/util/EnvironmentHelpers";

import Voucher from "features/vouchers";

import Sidebar from "shared/components/Footer/Sidebar";
import Section from "shared/components/Footer/Section";
import SeoLink from "shared/components/Footer/SeoLink";
import SignupLink from "shared/components/Footer/SignupLink";
import Copyright from "shared/components/Footer/Copyright";

import { FOOTER_SECTION_ORDER } from "shared/components/Footer/constants";

import "./index.scss";

if (process.env.PLATFORM === "desktop") {
	require("./index.desktop.scss");
}

const Footer = memo(() => {
	const isLoggedIn = !!Context.get("userid");
	const showMobileSiteLink = isDesktop && !!getMobileType();
	const extraLinks = [];

	if (!isLoggedIn) {
		extraLinks.push(<SeoLink key="seo" />);
		extraLinks.push(
			<button
				key="redeem"
				className="footer-section-link"
				onClick={() => { Voucher.open(); }}
			>
				<Str>Redeem Promotion</Str>
			</button>,
		);
	}

	if (isMobile) {
		extraLinks.push(
			<button
				key="mw-switch"
				className="footer-section-link"
				onClick={() => allowMobileMode(false)}
			>
				<Str>Switch to Desktop site</Str>
			</button>,
		);
	}

	if (showMobileSiteLink) {
		extraLinks.push(
			<button
				key="mw-switch"
				className="footer-section-link"
				onClick={() => allowMobileMode(true)}
			>
				<Str>Switch to Mobile Site</Str>
			</button>,
		);
	}

	return (
		<footer className="footer">
			{isMobile && !isLoggedIn && <SignupLink />}
			{isDesktop && (
				<Sidebar />
			)}
			{FOOTER_SECTION_ORDER.map((id) => (
				<Section
					key={id}
					id={id}
					extraLinks={extraLinks}
				/>
			))}
			{isMobile && <Copyright />}
		</footer>
	);
});

export default Footer;



// WEBPACK FOOTER //
// ./src/shared/components/Footer/index.jsx